import { CareplanPendingAction } from "@/constants/careplan";
import type { CareplanPendingAction as CareplanPendingActionType } from "@/types/careplan";
import { Badge, BADGE_STATUS } from "@/ui";

type ProfileCareplanPendingActionBadgeProps = {
  pendingAction: CareplanPendingActionType | null;
};

export const ProfileCareplanPendingActionBadge = ({
  pendingAction,
}: ProfileCareplanPendingActionBadgeProps) => {
  if (!pendingAction) {
    return null;
  }

  const badgeStatus =
    pendingAction === CareplanPendingAction.approve ? BADGE_STATUS.INFO : BADGE_STATUS.WARNING;

  return (
    <Badge className="capitalize" status={badgeStatus}>
      {pendingAction}
    </Badge>
  );
};
